import gql from '@zenbusiness/application-commons-utils/gql';

export const DELETE_INSTANT_FUNDING_CARD_MUTATION = gql`
  mutation deleteInstantFundingCard($cardUuid: UUID!) {
    deleteInstantFundingCard(cardUuid: $cardUuid)
  }
`;
